export default __webpack_public_path__ + "static/header-title-do-light-118937d83e9587a50495cbbfa0e1010fa2a03f96d60e3de883e3a3e43af0fd68.png";